import React from "react";
import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { IDownloadPdfTrips } from "../../../types/DownloadPdfTypes";
import DownloadPdfHeader from "./DownloadPdfHeader/DownloadPdfHeader";
import DownloadPdfBody from "./DownloadPdfBody/DownloadPdfBody";
import DownloadPdfFooter from "./DownloadPdfFooter/DownloadPdfFooter";
import { CreditCardDetails } from "../../../types/PaymentTypes";
import DownloadPdfBodyView from "./DownloadPdfBody/DownloadPdfBodyView";
import { useTripsCtx } from "../../../context/TripDetailsContext";
import { IWandaTripInfo, TTrip } from "../../../types/TripTypes";
import DownloadPdfTripLegCard from "./DownloadPdfBody/DownloadPdfTripLegCard";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFF",
    padding: 20,
  },
  row: {
    flexDirection: "row",
    marginBottom: 10,
  },
  colLeft: {
    flex: 2,
    backgroundColor: "#FFF",
    padding: 10,
  },
  colRight: {
    flex: 1,
    backgroundColor: "#FFF",
    padding: 10,
  },
  solidDivider: {
    borderTop: "1px solid #D9D9D9",
    marginVertical: 8,
  },
  costSeperationOrderDashed: {
    borderTop: "1px dashed #0063AF",
    marginVertical: 8,
    marginBottom: 16,
  },
  serviceSummaryStyle: {
    fontSize: 20,
    fontWeight: 800,
    lineHeight: 1.6,
    fontFamily: "Helvetica",
    marginBottom: 8,
    marginLeft: 8,
  },
});

type Props = {
  bookingId: string;
  wandaCustomerCareNumber: string;
  paymentInfo?: CreditCardDetails;
  wandaTripInfo: IWandaTripInfo;
  tripTotalCost: number;
  wandaDiscountTotalCost: Function;
  wandaPromoCodeTotalCost: Function;
  data: IDownloadPdfTrips;
};

const DownloadPdf: React.FC<Props> = ({
  bookingId,
  wandaCustomerCareNumber,
  paymentInfo,
  wandaTripInfo,
  tripTotalCost,
  wandaDiscountTotalCost,
  wandaPromoCodeTotalCost,
  data,
}) => {
  return (
    <Document>
      <Page size="A2" style={styles.page}>
        <DownloadPdfHeader />
        <View style={styles.serviceSummaryStyle}>
          <Text>Service Summary</Text>
        </View>
        <DownloadPdfBodyView
          trips={data}
          CreditCardDetails={paymentInfo}
          wandaPromoCodeTotalCost={wandaPromoCodeTotalCost}
          wandaDiscountTotalCost={wandaDiscountTotalCost}
          tripTotalCost={tripTotalCost}
          wandaTripInfo={wandaTripInfo}
          wandaCustomerCareNumber={wandaCustomerCareNumber}
        />
      </Page>
    </Document>
  );
};

export default DownloadPdf;
